import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { supabaseChangelog } from './supabase';
import './Changelog.css';

function Changelog() {
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    setIsLoading(true);
    const data = await supabaseChangelog.getAll();
    setEntries(data);
    setIsLoading(false);
  };

  const formatDate = (dateString) => {
    // Parse the date string and treat it as local time (not UTC)
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="changelog-container">
      <Helmet>
        <title>What's New | Film Revival NYC</title>
        <meta name="description" content="Latest updates and improvements to Film Revival NYC, your guide to revival and repertory cinema in New York City." />
        <meta property="og:title" content="What's New | Film Revival NYC" />
        <meta property="og:description" content="Latest updates and improvements to Film Revival NYC, your guide to revival and repertory cinema in New York City." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://filmrevivalnyc.com/changelog" />
        <meta property="og:image" content="https://filmrevivalnyc.com/FILM_REVIVAL_NY_OG.jpg" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="What's New | Film Revival NYC" />
        <meta name="twitter:description" content="Latest updates and improvements to Film Revival NYC, your guide to revival and repertory cinema in New York City." />
        <meta name="twitter:image" content="https://filmrevivalnyc.com/FILM_REVIVAL_NY_OG.jpg" />
        <link rel="canonical" href="https://filmrevivalnyc.com/changelog" />
      </Helmet>
      <div className="changelog-header">
        <Link to="/" className="back-link">← Back to Home</Link>
        <h1>Film Revival NYC - What's New</h1>
        <p className="changelog-subtitle">This page will track all updates and improvements to the site. As always, feel free to reach out to filmrevivalnyc@gmail.com to report bugs and missing showtimes or request new features. We'd love your feedback!</p>
      </div>

      <div className="changelog-entries">
        {isLoading ? (
          <p>Loading changelog entries...</p>
        ) : entries.length === 0 ? (
          <p className="no-entries">No changelog entries yet.</p>
        ) : (
          entries.map((entry) => (
            <div key={entry.id} className="changelog-entry">
              <div className="entry-header">
                <h3>{entry.title}</h3>
                <span className="entry-date">{formatDate(entry.date)}</span>
              </div>
              <div className="entry-description">
                <ReactMarkdown>{entry.description}</ReactMarkdown>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Changelog;

